// eslint-disable-next-line no-unused-vars
import React from 'react';
import Style from './backgroundInput.module.css';
import useAppContext from '../../../../../../context/useAppContext';
import UploadFileZone from '../../../../../../components/upload/uploadFileZone';
import { useTranslation } from 'react-i18next';

export default function BackgroundInput({ label, value, onChange = () => {}, ...params }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    const uploadDocumentUrl = React.useCallback(
        url => {
            onChange(url.url);
        },
        [onChange]
    );

    return (
        <div className={Style['fileArea']}>
            {label}
            <UploadFileZone
                subLabelDropzone={t('nacre.UploadButton.sub-label-dropzone')}
                maxSize={2097152}
                file={value}
                organization={organization}
                fileTypes={['.pdf']}
                onUpload={uploadDocumentUrl}
                onDelete={() => onChange(null)}
                {...params}
            />
        </div>
    );
}
